import { createFileRoute } from '@tanstack/react-router';
import { CoiDetailsManage } from './CoiDetailsManage';
import { useCoiEditAccess } from './useCoiEditAccess';

export const Route = createFileRoute('/console/$orgId/compliance/coi/details/$id/manage')({
    component: RouteComponent,
});

function RouteComponent() {
    const canEdit = useCoiEditAccess();

    return <CoiDetailsManage disabled={!canEdit} />;
}
